import { Injectable } from "@angular/core";
import { FeedListItem } from "../../models/feed-list-item.model";
import { FeedMetadataUpdateRequest } from "../../models/feed-override.model";
import { AdminCommonHttpService } from "../components/admin/service/admin-common-http.service";

@Injectable({
  providedIn: 'root'
})
export class FeedMetadataService {

  constructor(private http: AdminCommonHttpService) { }

  getFeedList(): Promise<FeedListItem[]> {
    return this.http.getFeedMetadataList();
  }

  getProductOverrides(productId: number): Promise<any[]> {
    return this.http.getFeedMetadataByProductId(productId.toString());
  }

  upsertFeedMetadata(productId: string, payload: FeedMetadataUpdateRequest): Promise<any> {
    return this.http.upsertFeedMetadataByProductId(productId, payload);
  }

  getDestinationFieldConfig(destination: string): Promise<any[]> {
    return this.http.getFeedOverrideFieldConfig(destination);
  }

  getOverridesForProductDestination(productId: string, destination: string): Promise<any[]> {
    return this.http.getOverridesForProductAndDestination(productId, destination);
  }

  getProductById(productId: string) {
    return this.http.getProductById(productId);
  }

  async getFeedDestinations() {
    return await this.http.getFeedDestinations();
  }

}
